import { render, staticRenderFns } from "./TagsCol.vue?vue&type=template&id=600eb05e&scoped=true"
import script from "./TagsCol.vue?vue&type=script&lang=js"
export * from "./TagsCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600eb05e",
  null
  
)

export default component.exports